export const FILETYPE_PDF = '.pdf'
export const MIMETYPE_PDF = 'application/pdf'

export enum FileType {
  CUSTOMER = 'customer',
  SUPPLIER = 'supplier',
}
